<script>
  import MediaQuery from './layouts/MediaQuery.svelte'
  import PC from './page/PC.svelte'
  import Mobile from './page/Mobile.svelte'
</script>
<main id="root">
  <MediaQuery query="(min-width: 641px)" let:matches>
    {#if matches}
      <PC />
    {/if}
  </MediaQuery>
  <MediaQuery query="(max-width: 640px)" let:matches>
    {#if matches}
    <Mobile />
    {/if}
  </MediaQuery>
</main>

<style>
	*{
		margin:0;
		padding: 0;
	}
  :global(html){
    scroll-padding: 70px;
  }
</style>